import ResponsivePagination from 'react-responsive-pagination';
import cls from 'clsx';

export interface PaginationProps {
    page: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}
export const Pagination = ({ page, totalPages, onPageChange }: PaginationProps) => {
    const onChange = (page: number) => {
        window.scrollTo(0, 0);

        if (onPageChange) {
            onPageChange(page)
        }
    }

    return (
        <ResponsivePagination
            className="btn-group flex justify-center my-4"
            pageItemClassName="btn btn-md sm:btn-lg border-0 p-0 page-item hover:bg-outline"
            pageLinkClassName="block flex items-center justify-center w-full h-full text-center p-2 xs:p-3 sm:p-4"
            activeItemClassName="btn-active"
            a11yActiveLabel=''
            ariaNextLabel=' '
            ariaPreviousLabel=' '
            total={totalPages}
            current={page}
            onPageChange={onChange}
        />
    )
}